const BREAKPOINT = 960;

class SanArenaRs {
  constructor() {
    this.item = 'kurs_web_kursliste';
    this.secondaryIdentifierValueName = 'company[secondary_identifier_value]';
    this.secondaryIdentifierName = 'company[secondary_identifier]';
    this.placeholderMap = {
      'Familienname Ansprechperson': 'Hier Familienname eingeben',
      Firma: 'Hier Name der Firma eingeben'
    };
  }

  applyTdHeightFromSrcInDist() {
    const self = this;
    Drupal.behaviors.sanarenarsWebKursliste = {
      attach(context) {
        once(self.item, `.${self.item}`).forEach((table) => {
          const tbodyTr = table.querySelector('tbody tr');
          const theadTr = table.querySelector('thead tr');

          if (!tbodyTr || !theadTr) {
            return;
          }

          self.onResize(tbodyTr, theadTr);

          let throttleTimer = null;

          window.addEventListener('resize', () => {
            if (throttleTimer) {
              return;
            }

            throttleTimer = setTimeout(() => {
              self.onResize(tbodyTr, theadTr);
              throttleTimer = null;
            }, 100);
          });
        });
      }
    };
  }

  applySecondaryIdentifierPlaceholder() {
    const self = this;
    Drupal.behaviors.sanarenarsSecondaryIdentifierPlaceholder = {
      attach(context) {
        once(
          'sanarenarsSecondaryIdentifierPlaceholder',
          `input[name="${self.secondaryIdentifierValueName}"]`,
          context
        ).forEach((valueInput) => {
          const form = valueInput.closest('form');
          const select = (form || document).querySelector(
            `select[name="${self.secondaryIdentifierName}"]`
          );

          if (!select) {
            return;
          }

          self.updateSecondaryIdentifierPlaceholder(select, valueInput);

          select.addEventListener('change', () => {
            self.updateSecondaryIdentifierPlaceholder(select, valueInput);
          });
        });
      }
    };
  }

  updateSecondaryIdentifierPlaceholder(select, valueInput) {
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption) {
      return;
    }

    const selectedText = selectedOption.textContent.trim();
    const placeholder = this.placeholderMap[selectedText];

    if (placeholder) {
      valueInput.setAttribute('placeholder', placeholder);
    }
  }

  clearTdHeight(dist) {
    [...dist.childNodes]
      .filter((n) => n.nodeType === Node.ELEMENT_NODE)
      .forEach((td) => {
        td.style.height = '';
      });
  }

  onResize(src, dist) {
    if (window.innerWidth < BREAKPOINT) {
      this.setTdHeightFromSrcInDist(src, dist);
    } else {
      this.clearTdHeight(dist);
    }
  }

  setTdHeightFromSrcInDist(src, dist) {
    const srcCells = [...src.childNodes].filter(
      (n) => n.nodeType === Node.ELEMENT_NODE
    );
    const distCells = [...dist.childNodes].filter(
      (n) => n.nodeType === Node.ELEMENT_NODE
    );

    srcCells.forEach((td, index) => {
      const height = td.getBoundingClientRect().height;
      distCells[index].style.height = `${height}px`;
    });
  }

  run() {
    this.applyTdHeightFromSrcInDist();
    this.applySecondaryIdentifierPlaceholder();
  }
}

export default SanArenaRs;
